/**
 * Formata o endereço de contato (número, LID ou grupo).
 * Exemplos:
 * - Contato com número: formata como telefone brasileiro
 * - Contato sem número mas com LID: retorna ""
 * - Grupo: retorna "Grupo"
 *
 * Mantém o número original se não conseguir formatar.
 */
const telefoneFormatar = (oContato) => {
  if (!oContato) return ""

  if (oContato.isGroup) return "Grupo"

  const cNumero = oContato.numero ?? oContato.number
  const cLid = oContato.lid

  if (typeof cNumero === "string" && cNumero.length > 0 && cNumero.length < 14) {
    try {
      const cApenasNumeros = String(cNumero).replace(/\D/g, "")

      // Early return para números muito curtos
      if (cApenasNumeros.length < 8) return cNumero

      // Remove código do país 55 se presente
      let cNumeroSemCodPais = cApenasNumeros
      let lTemCodigoPais = false
      if (cApenasNumeros.startsWith("55") && cApenasNumeros.length >= 12) {
        cNumeroSemCodPais = cApenasNumeros.substring(2)
        lTemCodigoPais = true
      }

      // Formata conforme o tamanho
      if (cNumeroSemCodPais.length === 11) {
        // Celular: (XX) XXXXX-XXXX
        const cDDD = cNumeroSemCodPais.substring(0, 2)
        const cPrimeiraParte = cNumeroSemCodPais.substring(2, 7)
        const cSegundaParte = cNumeroSemCodPais.substring(7)
        return `${lTemCodigoPais ? "+55 " : ""}(${cDDD}) ${cPrimeiraParte}-${cSegundaParte}`
      }

      if (cNumeroSemCodPais.length === 10) {
        // Fixo: (XX) XXXX-XXXX
        const cDDD = cNumeroSemCodPais.substring(0, 2)
        const cPrimeiraParte = cNumeroSemCodPais.substring(2, 6)
        const cSegundaParte = cNumeroSemCodPais.substring(6)
        return `${lTemCodigoPais ? "+55 " : ""}(${cDDD}) ${cPrimeiraParte}-${cSegundaParte}`
      }

      if (cNumeroSemCodPais.length === 9) {
        // Celular sem DDD: XXXXX-XXXX
        return `${cNumeroSemCodPais.substring(0, 5)}-${cNumeroSemCodPais.substring(5)}`
      }

      if (cNumeroSemCodPais.length === 8) {
        // Fixo sem DDD: XXXX-XXXX
        return `${cNumeroSemCodPais.substring(0, 4)}-${cNumeroSemCodPais.substring(4)}`
      }

      // Não conseguiu classificar: devolve original
      return cNumero
    } catch (oErro) {
      // Em caso de erro, retorna original
      return String(cNumero || "")
    }
  }

  return ""
}

export { telefoneFormatar as default }
